function normalizeHost(host: string | null | undefined): string {
	return String(host || '').trim().toLowerCase();
}

export function isFeatureFlagHostAllowed(
	allowedHosts: string[] | undefined,
	currentHost: string | null | undefined
): boolean {
	if (!allowedHosts || allowedHosts.length === 0) {
		return true;
	}

	const normalizedCurrent = normalizeHost(currentHost);
	if (!normalizedCurrent) {
		return false;
	}

	return allowedHosts.some((host) => normalizeHost(host) === normalizedCurrent);
}
